import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../utils/Adapters';
import { CMSAPI } from '../../../utils/CmsAPI';
import config from '../../../config';

const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const massageData = (response) => {
  const responseData = response.data;
  return responseData.result.assets[0].content.content;
};

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const fetchData = () => {
  /*
    const url = CMSAPI(
      config.lscsPath,
      'siteconfig',
      config.pageType.siteconfig,
      config.cmsProjectName,
      false,
    );
  */

  // CU-3351 HK Shopping Festival - Change the API to use JSON file instead
  const url = process.env.REACT_APP_STAGE.includes('Preview')
    ? CMSAPI(
        config.lscsPath,
        'siteconfig',
        config.pageType.siteconfig,
        config.cmsProjectName,
        false,
      )
    : `${process.env.REACT_APP_PORTAL_DOMAIN}/resources/data/${config.cmsProjectName}/Settings/Site%20Config/siteconfig___NaN-NaN.json`;

  return axiosAdapter({
    url,
  });
};

const getSiteConfig = () => {
  return (dispatch) => {
    dispatch(requestFetch());
    return fetchData()
      .then((response) => massageData(response))
      .then((data) => {
        dispatch(receiveSuccess(data));
      })
      .catch((error) => {
        const message = messageError(error);
        dispatch(receiveError(message));
      });
  };
};

export { getSiteConfig };
